export const habaAddress = {
  habaAddressForm: {
    heading: 'Où allons-nous ?',
    section: {
      billingAddress: 'Adresse de facturation',
      shippingAddress: 'Adresse de livraison',
      address: 'Adresse',
      title: 'Titre de civilité',
    },
    useThisShippingAddress: 'Envoyer à cette adresse',
    useThisBillingAddress: 'Utiliser comme adresse de facturation',
    personalData: 'Quelles sont tes données personnelles?',
    newAddressHeadline: 'Ajouter une nouvelle adresse',
    newAddressButton: 'Nouvelle adresse',
    editNewAddressHeadline: "Modifier l'adresse",
    saveAddress: "Enregistrer l'adresse",
    submitChanges: 'SAUVEGARDER LES MODIFICATIONS',
    billingAddressRequired: 'Vous devez sélectionner une adresse de facturation',
    deliveryAddressRequired: 'Vous devez sélectionner une adresse de livraison',
    deliveryAddressCountryMismatch:
      "L'adresse de livraison sélectionnée n'appartient pas à cette boutique. Veuillez sélectionner une adresse de livraison dans ce pays ou en ajouter une nouvelle.",
    editDeliveryAddress: `Modifier l'adresse de livraison`,
    editBillingAddress: `Modifier l'adresse de facturation`,
    editDeliveryMethod: `Modifier le mode d'expédition`,
    editPaymentMethod: 'Modifier le mode de paiement',
    editEmailAddress: `Modifier l'adresse e-mail`,
    form: {
      privateCompanyToggle: {
        private: 'Client privé',
        company: 'Entreprise cliente',
      },
      firm: 'Entreprise cliente',
      title: {
        label: 'Titre de civilité*',
        error: 'Veuillez choisir un titre',
      },
      firstName: {
        label: 'Prénom*',
        error: 'Veuillez saisir votre prénom',
      },
      lastName: {
        label: 'Nom de famille*',
        error: 'Veuillez saisir votre nom de famille',
      },
      name: {
        label: 'Name*',
        error: 'Veuillez saisir votre nom',
      },
      companyName: {
        label: 'Entreprise*',
        error: "Veuillez saisir l'entreprise",
      },
      address1: {
        label: 'Rue*',
        error: 'Veuillez saisir la rue',
      },
      nr: {
        label: 'Numéro de rue*',
        error: 'Veuillez saisir le numéro',
      },
      address2: {
        label: "Supplément d'adresse (optionnel)",
      },
      country: {
        label: 'Pays*',
        error: 'Veuillez sélectionner un pays',
      },
      city: {
        label: 'Ville*',
        error: 'Veuillez saisir la ville',
      },
      zipCode: {
        label: 'Code postal*',
        errorRequired: 'Veuillez indiquer un code postal.',
        errorDefault: 'Veuillez vérifier que le format du code postal saisi est correct.',
        pattern: {
          errorMainText: 'Veuillez vérifier que le code postal saisi est correct. Format: ',
          // following the zip code example patterns (that are shown after "errorMainText")
          '^[0-9]{3}$': '123',
          '^[0-9]{4}$': '1234',
          '^[0-9]{5}$': '12345',
          '^AD[1-7]00$': 'AD100',
          '^(FO-)?[0-9]{3}$': 'FO-100',
          '^GX11 1AA$': 'GX11 1AA',
          '^[A-Za-z0-9]{3} [A-Za-z0-9]{4}$': 'A99 A9A9',
          '^MD-[0-9]{4}$': 'MD-9999',
          '^[A-Za-z]{2,3} [0-9]{4}$': 'AAA 9999',
          '^[0-9]{4} ?[A-Za-z]{2}$': '9999ZZ',
          '^[0-9]{2}-[0-9]{3}$': '99-999',
          '^[0-9]{4}-[0-9]{3}$': '9999-999',
          '^[0-9]{3}[ -]?[0-9]{2}$': '999 99',
          '^[0-9]{3} ?[0-9]{2}$': '999 99',
        },
      },
      lengthError: 'Ce champ est obligatoire et doit contenir entre 1 et 255 caractères.',
      phone: {
        required: 'Veuillez saisir votre numéro de téléphone',
        pattern: 'Aucun numéro de téléphone valide',
      },
      day: {
        label: 'Tag*',
        error: 'Bitte Tag eingeben',
      },
      month: {
        label: 'Monat*',
        error: 'Bitte Monat eingeben',
      },
      year: {
        label: 'Jahr*',
        error: 'Bitte Jahr eingeben',
      },
    },
    billingAddress: {
      selectAddress: "Sélectionne l'adresse associée à ta carte ou à ton moyen de paiement.",
      sameWithShippingAddress: "Identique à l'adresse de livraison",
    },
    selectDifferentDeliveryAddress: 'Sélectionner une autre adresse de livraison',
    selectDifferentBillingAddress: 'Sélectionner une autre adresse de facturation',
    choose: 'Sélectionner',
    salesForPrivateMatters:
      "La vente est exclusivement réservée à l'usage privé et non commercial du client.",
    birthdate: 'date de naissance',
    optinalInformation: 'Coordonnées facultatives',
    updateAccountButtonText: 'MODIFIER ET ENREGISTRER LES DONNÉES',
    customerDetailsUpdatedSuccesfully: "Vos coordonnées client viennent d'être mises à jour",
  },
  habaAddressMelissa: {
    heading: "Vérification de l'adresse",
    paragraph:
      "Cher client, nous ne connaissons malheureusement pas ton adresse. Veuillez vérifier ces propositions d'adresse et confirmer votre adresse",
    suggestions: 'Tu voulais peut-être dire:',
    yourInput: 'Ta saisie:',
    submitButton: 'ACCEPTER LA SÉLECTION ET CONTINUER',
  },
};
